import { imageAssetUrl } from "@/utils/url";

export function InsightLogo() {
  return (
    <img
      src={imageAssetUrl("insight.webp")}
      className="h-[1.125rem] aspect-auto"
    />
  );
}
